import { ContentCard } from "@msuite/ui/content-card";
import { DataGrid } from "@msuite/ui/data-grid";
import { icon } from "@msuite/ui/icons";
import { Panels } from "@msuite/ui/panels";
import type { Tables } from "@msuite/utils/types";
import Notes from "@/components/notes";
import type { PartnerPanelBaseProps } from "../types";
import { PartnerDirectionRow } from "./partner-direction-row";

/** Props Interface */
interface PartnerGeneralProps extends PartnerPanelBaseProps {
	organizationName: string;
	partnerships: Array<Tables<"organizationPartnerships">>;
}

export function PartnerGeneral({
	orgId,
	partnershipId,
	organizationName,
	partnerships,
}: PartnerGeneralProps) {
	/** Render */
	return (
		<Panels>
			<Panels.Panel flex={1}>
				<ContentCard
					title="Information"
					icon={icon("Info")}
				>
					<DataGrid>
						{partnerships.map((partnership) => (
							<PartnerDirectionRow
								key={partnership.id}
								orgId={orgId}
								organizationName={organizationName}
								partnership={partnership}
							/>
						))}
					</DataGrid>
				</ContentCard>
			</Panels.Panel>
			<Panels.Panel flex={2}>
				<Notes
					notesTable="organizationPartnershipNotes"
					identifier={partnershipId}
				/>
			</Panels.Panel>
		</Panels>
	);
}
